export const categoriesConfig = [
    {code: "notany", display: "Ни к какой из перечисленных"},
    {
        code: "childorphan",
        display: "Дети-сироты, дети, оставшиеся без попечения родителей, лица из числа детей сирот и детей, оставшихся без попечения родителей"
    },
    {code: "disability", display: "Лица, имеющие инвалидность"},
    {code: "personswithdisabilities", display: "Лица с ограниченными возможностями здоровья"},
    {code: "veterans", display: "Ветераны и учатники боевых действий"},
    {
        code: "childrenwithdisabilities",
        display: "Дети инвалидов I группы младше 20 лет из неполных малоимущих семей"
    },
    {code: "military", display: "Военнослужащие и сотрудники силовых ведомств"},
    {
        code: "childrenmedicalworkers",
        display: "Дети медицинских работников, умерших от COVID-19"
    },
    {code: "childrenmilitary", display: "Дети военнослужащих и сотрудников силовых ведомств"},
    {
        code: "Chernobyl",
        display: "Лица, подвергшиеся воздействию радиации вследствии катастрофы на Чернобыльской АЭС"
    },
    {
        code: "heroes",
        display: "Герои Российской Федерации, лица, награжденные тремя орденами Мужества, в том числе в рамках СВО"
    },
    {
        code: "svo",
        display: "Военнослужащие и сотрудники силовых ведомств, участвовавшие в СВО или боевых действиях на территории других государств или их дети"
    },
];

const bakalavrCategies = [
    "notany",
    "childorphan",
    "disability",
    "personswithdisabilities",
    "veterans",
    "childrenwithdisabilities",
    "military",
    "childrenmedicalworkers",
    "childrenmilitary",
    "Chernobyl",
    "heroes",
    "svo",
]

const spo = [
    "notany",
    "childorphan",
    "disability",
    "personswithdisabilities",
    "veterans",
    "childrenwithdisabilities",
    "military",
    "childrenmedicalworkers",
    "childrenmilitary",
    "Chernobyl",
    "heroes",
    "svo",
]

export const categories = new Map<string, any[]>([
    ["БАКСПЕЦ", categoriesConfig.filter(item => bakalavrCategies.includes(item.code))],
    ["СПО11КЛАССОВ", categoriesConfig.filter(item => bakalavrCategies.includes(item.code))],
    ["СПО9КЛАССОВ", categoriesConfig.filter(item => bakalavrCategies.includes(item.code))],
    ["000000002", categoriesConfig.filter(item => bakalavrCategies.includes(item.code))],
    ["0000000012", categoriesConfig.filter(item => spo.includes(item.code))]
]);